import {mapActions, mapGetters, mapMutations} from "vuex";


export default {
    name: "read-more",
    props: {
        card: {
            type: String,
            default: ''
        }
    },
    components: {},
    data() {
        return {}
    },
    created() {
        this.fetchNews(this.$route.params.slug)
    },
    computed: {
        ...mapGetters({
            currentNews: 'home/currentNews'
        })
    },
    methods: {
        ...mapMutations({}),
        ...mapActions({
            fetchNews: 'home/CURRENT_NEWS'
        }),

    }
}
